export const IFRAME_RESIZER_SCRIPT_CDN =
  'https://s91588.cdn.ngenix.net/npm/iframe-resizer@4.2.1/js/iframeResizer.contentWindow.min.js';
